import React, { Component } from 'react';

export class ErrorMessage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            errors: this.props.errors
        }
    }

    static getDerivedStateFromProps(nextProps){
        return { errors: nextProps.errors };
    }

    render () {
        const error = this.state.errors[this.props.for]
        if (error) {
            return (
                <span className="text-error tickets-error-block">
                    {error}
                </span>
            )
        }
        else {
            return null
        }
    }
}

export class ErrorMessages extends ErrorMessage {

    render () {
        var errItems = Object.keys(this.state.errors).map(errType => { 
            return <ErrorMessage 
                errors={this.state.errors} 
                key={errType}
                for={errType} />
        });
        return <>{errItems}</>
    }
}
